<template>
    <el-drawer title="阶段配置" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                <el-form-item prop="number" label="解锁人数:">
                    <el-input-number v-model="formData.number" :min="0" :max="9999999" :precision="0"
                        style="width:100%" :disabled="formData.stage === 0 ? true : false"></el-input-number>
                </el-form-item>
                <el-form-item prop="pic" label="活动封面:">
                    <image-upload :url.sync="formData.pic" :urlFull.sync="formData.pic" ref="posterUpload"
                        class="poster-upload" @onSuccess="handleImageSuccess">
                    </image-upload>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()">确定</el-button>
        </div>
    </el-drawer>
</template>

<script>
import ImageUpload from '@/components/ImageUpload';
const defaultFormData = {
    number: 1,
    pic: '',
    stage: ''
}
export default {
    components: { ImageUpload },
    data() {
        return {
            drawerShow: false,
            formData: {
                ...defaultFormData
            },
            rules: {
                number: [{ required: true, message: "请输入解锁人数" }],
                pic: [{ required: true, message: "请上传图片" }],
            },
        }
    },
    methods: {
        show(data) {
            this.formData = {
                ...defaultFormData,
                ...data
            };
            this.drawerShow = true;
        },
        close() {
            this.formData = {
                ...defaultFormData,
            };
            this.drawerShow = false;
        },
        //图片上传成功后执行 
        handleImageSuccess() {
            if (this.formData.pic) {
                this.$refs["formData"].clearValidate('pic');
            }
        },
        //表单提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.$emit('onUpdate', this.formData);
                    this.close();
                } else {
                    return false;
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped></style>